import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import NotFound from '@/components/NotFound/NotFound';
import type { AppConfig } from '@/configuration/appConfiguration';
import { Providers } from '@/providers/Providers';

export type RouterContext = {
  config: AppConfig;
};

function RootComponent() {
  const { config } = Route.useRouteContext();

  return (
    <Providers config={config}>
      <div className='mx-auto w-full max-w-xl px-4 text-center'>
        <Outlet />
      </div>
    </Providers>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
});
